import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import FilterComponent from './FilterComponent';
import DatePickerField from '../../recordDetail/fields/DatePickerField';

import '../Filter.css';

class FilterDateRange extends FilterComponent {
  static get propTypes() {
    return {
      filterKeyStart: PropTypes.string,
      filterKeyEnd: PropTypes.string,
      setDisplayFilter: PropTypes.func,
      filterValueStart: PropTypes.any,
      filterValueEnd: PropTypes.any,
      onFilterDateRange: PropTypes.func,
      mapFn: PropTypes.func,
      labelStart: PropTypes.string,
      labelEnd: PropTypes.string
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      filterValueStart: props.filterValueStart || undefined,
      filterValueEnd: props.filterValueEnd || undefined
    };
  }

  onFilter() {
    const { onFilterDateRange, filterKeyStart, filterKeyEnd } = this.props;
    const { filterValueStart, filterValueEnd } = this.state;

    const filterObj = {};
    filterObj[filterKeyStart] = filterValueStart;
    filterObj[filterKeyEnd] = filterValueEnd;

    onFilterDateRange(filterObj);
  }

  onChange(key, updatedDateString) {
    const newValue = moment(updatedDateString).isValid() ? updatedDateString : undefined;
    const stateObj = {};
    stateObj[key] = newValue;
    this.setState(stateObj);
  }

  getDateObject(filterValue) {
    const dateObj = filterValue
      ? { Date: filterValue }
      : undefined;

    return dateObj;
  }

  renderFilterBody() {
    const { filterKeyStart, filterKeyEnd, labelStart, labelEnd } = this.props;
    const { filterValueStart, filterValueEnd } = this.state;
    const valueStart = this.getDateObject(filterValueStart);
    const valueEnd = this.getDateObject(filterValueEnd);

    return (
      <div className={classnames('Filter-body', `filter-body-${filterKeyStart}`)}>
        <DatePickerField
          required={false}
          editing
          name={`filter-date-${filterKeyStart}`}
          label={labelStart}
          className={classnames('datepicker', `date-filter-${filterKeyStart}`)}
          onChange={updatedValue => this.onChange('filterValueStart', updatedValue)}
          value={valueStart}
          maxDate={valueEnd}
          placeholder={labelStart}
          validationMessage={null}
          external
        />
        <DatePickerField
          required={false}
          editing
          name={`filter-date-${filterKeyEnd}`}
          label={labelEnd}
          className={classnames('datepicker', `date-filter-${filterKeyEnd}`)}
          onChange={updatedValue => this.onChange('filterValueEnd', updatedValue)}
          value={valueEnd}
          minDate={valueStart}
          placeholder={labelEnd}
          validationMessage={null}
          external
        />
      </div>
    );
  }
}

export default FilterDateRange;



// WEBPACK FOOTER //
// ./src/filter/filterTypes/FilterDateRange.js